import { Masks, StringUtils } from '@elotech/components';
import { handleCnpjUpperCaseKeyDown } from 'itbi-common/utils/MaskUtils';
import React from 'react';
import MaskedInput from 'react-text-mask';

type Props = Omit<
  React.ComponentProps<typeof MaskedInput>,
  'mask' | 'onKeyDown'
> & {
  tipoPessoa?: string;
};

const getMaskByValor = (valor: string) =>
  /^\d{0,11}$/.test(StringUtils.somenteNumerosELetras(valor))
    ? Masks.MASK_CPF
    : Masks.MASK_CNPJ;

const CpfCnpjInput = ({ tipoPessoa, maxLength, ...rest }: Props) => {
  if (!tipoPessoa) {
    return (
      <MaskedInput
        mask={getMaskByValor}
        onKeyDown={handleCnpjUpperCaseKeyDown}
        maxLength={maxLength ?? 19}
        {...rest}
      />
    );
  }

  const isFisica = tipoPessoa === 'FISICA';
  return (
    <MaskedInput
      mask={isFisica ? Masks.MASK_CPF : Masks.MASK_CNPJ}
      onKeyDown={!isFisica ? handleCnpjUpperCaseKeyDown : undefined}
      maxLength={maxLength ?? (isFisica ? 15 : 19)}
      {...rest}
    />
  );
};

export default CpfCnpjInput;
